// extracted by mini-css-extract-plugin
export default {"StepBoard":"Styles_StepBoard__OC6K6","active":"Styles_active__czKMh"};